
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class ProductPartyDetailsGrid extends Serenity.EntityGrid<ProductPartyDetailsRow, any> {
        protected getColumnsKey() { return 'OMS.ProductPartyDetails'; }
        protected getDialogType() { return ProductPartyDetailsDialog; }
        protected getIdProperty() { return ProductPartyDetailsRow.idProperty; }
        protected getInsertPermission() { return ProductPartyDetailsRow.insertPermission; }
        protected getLocalTextPrefix() { return ProductPartyDetailsRow.localTextPrefix; }
        protected getService() { return ProductPartyDetailsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}